import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Plus, Minus } from "lucide-react";
import { toast } from "sonner";

export default function AdminInventory() {
    const [items, setItems] = useState([]);
    const [q, setQ] = useState("");
    const [low, setLow] = useState(false);

    const load = async () => {
        const r = await api.get("/admin/inventory");
        setItems(r.data);
    };
    useEffect(() => { load(); }, []);

    const adjust = async (productId, sku, delta) => {
        try {
            await api.post(`/admin/products/${productId}/stock`, { sku, delta, reason: "manual_adjust" });
            toast.success(`Stock ${delta > 0 ? "+" : ""}${delta}`);
            load();
        } catch (e) {
            toast.error("Failed to adjust stock");
        }
    };

    const filtered = items.filter(i => {
        if (low && i.available > i.low_threshold) return false;
        if (q && !(`${i.title} ${i.sku} ${i.color} ${i.size}`.toLowerCase().includes(q.toLowerCase()))) return false;
        return true;
    });

    return (
        <div data-testid="admin-inventory-page">
            <h1 className="font-display text-4xl">Inventory</h1>
            <p className="text-muted-foreground mt-1">{items.length} SKUs across the catalog.</p>

            <Card className="mt-6 rounded-[20px] border-[#E7DED2] bg-white/80">
                <CardContent className="p-4">
                    <div className="flex flex-wrap gap-3 mb-4 items-center">
                        <Input placeholder="Search SKU, product, color…" value={q} onChange={e => setQ(e.target.value)} className="max-w-sm rounded-full bg-[#FAF7F1] border-[#E7DED2]" />
                        <label className="flex items-center gap-2 text-sm cursor-pointer">
                            <input type="checkbox" checked={low} onChange={e => setLow(e.target.checked)} /> Show low-stock only
                        </label>
                    </div>
                    <div className="overflow-x-auto">
                        <table className="w-full text-sm">
                            <thead>
                                <tr className="text-left text-xs font-mono-ui text-muted-foreground border-b border-[#E7DED2]">
                                    <th className="py-3">Product</th><th>SKU</th><th>Variant</th><th>Stock</th><th>Reserved</th><th>Available</th><th>Adjust</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filtered.map(i => (
                                    <tr key={i.sku} className={`border-b border-[#F4EFE6] ${i.available <= i.low_threshold ? "bg-[#C07A5A]/5" : ""}`} data-testid={`admin-inventory-row-${i.sku}`}>
                                        <td className="py-3">
                                            <div className="flex items-center gap-3">
                                                <img src={i.image} alt="" className="h-10 w-10 rounded-xl object-cover" />
                                                <p className="font-medium">{i.title}</p>
                                            </div>
                                        </td>
                                        <td className="font-mono text-xs">{i.sku}</td>
                                        <td>{i.color} / {i.size}</td>
                                        <td>{i.stock}</td>
                                        <td>{i.reserved}</td>
                                        <td className={i.available <= i.low_threshold ? "text-[#C07A5A] font-semibold" : ""}>{i.available}</td>
                                        <td>
                                            <div className="flex gap-1">
                                                <button onClick={() => adjust(i.product_id, i.sku, -1)} className="h-8 w-8 rounded-full bg-[#F4EFE6] flex items-center justify-center hover:bg-[#E7DED2]"><Minus className="h-3 w-3" /></button>
                                                <button onClick={() => adjust(i.product_id, i.sku, 1)} className="h-8 w-8 rounded-full bg-[#F4EFE6] flex items-center justify-center hover:bg-[#E7DED2]"><Plus className="h-3 w-3" /></button>
                                                <button onClick={() => adjust(i.product_id, i.sku, 10)} className="h-8 px-2 text-xs rounded-full bg-[#121214] text-white">+10</button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
